export default userState => {
  return {
    fresh: 'shown_10dollar_modal',
    expired_valid_card: 'shown_expired_with_valid_card_modal',
    expired_invalid_card: 'shown_expired_with_invalid_card_modal',
    curious_about_even_more_ranking_lists: 'gold_wants_more_lists_shown_contact_support_modal',
    curious_about_ranking_lists: 'shown_ranking_upgrade_modal',
    out_of_ranking_lists: 'shown_ranking_upgrade_modal'
  }[userState];
}